/**
 * Configuration file for environment variables.
 *
 * This file exports constants that are derived from environment variables.
 * It is used to centralize the configuration settings for the application.
 */

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL as string;
export const WEB_BASE_URL = API_BASE_URL + '/web/';
export const ME_BASE_URL = API_BASE_URL + '/me/';
export const BASE_URL = process.env.REACT_APP_BASE_URL as string;
export const HOTEL_NOT_SHOWING_PAYMENT_REQUIRED_DISCLAIMER = process.env.REACT_APP_HOTEL_NOT_SHOWING_PAYMENT_REQUIRED_DISCLAIMER as string;
export const PREBOOKING_EXPIRES_IN = process.env.REACT_APP_PREBOOKING_EXPIRES_IN as number;
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string;
export const POKER_STARS_HOST = process.env.REACT_APP_POKERSTARS_HOST as string
export const CLIENT_ID_POKER_STARS = process.env.REACT_APP_OIDC_CLIENT_ID_POKERSTARS as string
export const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID as string;
export const OIDC_URL = process.env.REACT_APP_OIDC_URL as string;
export const OIDC_REALM = process.env.REACT_APP_OIDC_REALM as string;
